<template>
  <v-container pa-3>
    <v-layout row wrap>
      <v-flex xs12>
        <v-form ref="form" v-model="form_valid">
          <v-layout row wrap>
            <v-flex md3 sm6 xs12 pa-1>
              <v-text-field
                v-model="datas.code"
                required
                :label="$t('doc_no')"
                append-icon="fas fa-plus-circle"
                hide-details
                @click:append="doNewGuid"
              />
            </v-flex>
            <v-flex md3 sm6 xs12 pa-1>
              <v-select
                :items="type_Time"
                :item-text="$t('txt')"
                item-value="val"
                :label="$t('type')"
                v-model="number_tab"
                @change="checktab()"
              >
                <template slot="item" slot-scope="{item}">
                  <div>{{ $t(''+item.txt) }}</div>
                </template>
              </v-select>
            </v-flex>
            <v-flex md3 sm6 xs12 pa-1>
              <v-text-field
                :label="$t('date')"
                type="date"
                v-model="datas.date"
                required
                hide-details
              />
            </v-flex>
            <v-flex md3 sm6 xs12 pa-1>
              <v-text-field
                :label="$t('remark')"
                type="text"
                v-model="datas.remark"
                required
                hide-details
              />
            </v-flex>

            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select
                required
                :items="branch_items"
                :label="$t('branch')"
                item-text="name"
                item-value="code"
                v-model="branch"
                hide-details
                @input="getProfileDepartmentList()"
              />
            </v-flex>
            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select
                required
                :items="department_items"
                :label="$t('Department')"
                item-text="name"
                item-value="code"
                v-model="department"
                hide-details
                :disabled="department_items.length ==''"
                @input="getEmployeeList()"
              />
            </v-flex>

            <v-flex md4 sm6 xs12 pa-1>
              <v-select
                v-model="name"
                :items="Employee_list"
                item-text="name"
                item-value="name"
                :label="$t('employee_code')"
                :disabled="Employee_list.length ==''"
                multiple
              >
                <template slot="prepend-item">
                  <v-list-tile ripple @click="toggle" class="checkEmp">
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="isChecked"
                        color="primary"
                        :indeterminate="selectSomeEmp"
                      ></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Select All</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template slot="append-item">
                  <v-divider class="mb-2"></v-divider>
                </template>
              </v-select>
            </v-flex>
            <v-flex md2 sm6 xs12 style="margin-right:15px;"  v-if="permission_edit == true || admin == 'true'">
              <v-btn color="warning" block class="white--text" @click="CreateDoc()">
                <p style=" font-size:12px;position: absolute;margin-top:15px;">{{$t('DownloadExample')}}</p>
              </v-btn>
            </v-flex>
            <v-flex md2 sm6 xs12 class="button-wrapper"  v-if="permission_edit == true || admin == 'true'">
              <span class="label">{{$t('Upload')}}</span>
              <input
                :label="$t('ImportIncome')"
                type="file"
                id="file"
                ref="myFiles"
                class="upload-box"
                multiple
                @change="ImportExcel()"
                placeholder="Upload File"
              />
            </v-flex>
          </v-layout>
        </v-form>
        <v-flex md12 sm12 xs12>
          <v-layout row wrap v-if="finger_scan_data.length > 0">
            <v-flex
              md12
              sm12
              xs12
              v-for="(item, index) in finger_scan_data"
              :key="index"
              @click="''"
            >
              <v-card class="coco-box-shadow coco-list-hover">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg1 md1 sm2 xs3 text-xs-center>
                    <v-avatar :size="64">
                      <v-avatar
                        v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                        :size="64"
                        color="teal"
                      >
                        <span class="white--text headline">{{item.nick_name}}</span>
                      </v-avatar>

                      <Empimage
                        v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                        :json_data="item.emp_images"
                      />
                    </v-avatar>
                  </v-flex>
                  <v-flex lg9 md9 sm8 xs9>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <span
                          class="coco-list-label-text"
                        >{{isEmpty(item.emp_code)? item.emp_code : 'emp_code'}}:</span>
                        <span>{{item.name}}</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs2>
                            <span class="coco-list-label-icon">
                              <v-icon>date_range</v-icon>
                              <span>{{formatdate(item.date_finger_scan)}}</span>
                            </span>
                          </v-flex>
                          <v-flex xs2>
                            <span class="coco-list-label-icon">
                              <v-icon>access_time</v-icon>
                              <span>{{item.time_finger_scan}}</span>
                            </span>
                          </v-flex>
                          <v-flex xs2>
                            <span class="coco-list-label-icon">
                              <v-icon>info</v-icon>
                              <span>{{isEmpty(item.remark) ? item.remark : '-'}}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs12>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-right>
                        <v-layout row wrap text-xs-right>
                          <v-flex offset-lg5 offset-md3 offset-xs4 lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="EditItem(item,index)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs2>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="deleteItem(item,index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{$t('delete')}}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn color="#D84315" @click="back()">
                <v-icon class="mr-2" style="color:#ffffff">fas fa-arrow-left</v-icon>
                <span style="color:#ffffff">{{$t('back')}}</span>
              </v-btn>
              <v-btn color="#43A047" @click="dialog = false;onSave()">
                <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
                <span style="color:#ffffff">{{$t('save')}}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>

      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('EditDocument')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('code')"
                      v-model="form_dialog.emp_code"
                      required
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('name')" v-model="form_dialog.name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('date')"
                      type="date"
                      v-model="form_dialog.date_finger_scan"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('detail')" v-model="form_dialog.remark" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('duration')"
                      v-model="form_dialog.time_finger_scan"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="dialog = false;onUpdate()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Form Create Doc -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog_create" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('CreateDocument')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('date')"
                      type="date"
                      v-model="form_dialog_create.date"
                      required
                      hide-details
                      :rules="form_rules.date"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('detail')"
                      v-model="form_dialog_create.remark"
                      required
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog_create = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="DownloadExampleExcel()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Empimage from "../../components/getempimage.vue";
import UserService from "@/services/UserService";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
    type_Time: [
      { txt: "Absence", val: 0 },
      { txt: "TakeLeave", val: 1 },
      { txt: "Late", val: 2 },
      { txt: "DepartBeforeTime", val: 3 },
      { txt: "Specialholiday", val: 4 }
    ],
    number_tab: 0,
    dialog_create: false,
    branch: "",
    department: "",
    branch_items: [],
    department_items: [],
    Employee_list: [],
    Employee_items: [],
    isChecked: false,
    form_valid: false,
    dialog: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    form_rules: {
      date: [v => !!v || "do not empty."]
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    index: 0,
    form_dialog: {
      emp_code: "",
      name: "",
      date_finger_scan: "",
      time_finger_scan: "",
      remark: ""
    },
    form_dialog_create: {
      date: "",
      remark: ""
    },
    head_example: [],
    detail_example: [],
    datas: {
      code: "",
      remark: "",
      date: new Date().toISOString().slice(0, 10),
      creator_code: localStorage._usercode,
      details: []
    },
    results: [],
    finger_scan_data: [],
    name: [],
    checkdata: true,
    permission_edit :false,
    permission_view:false,
    admin:false,
     empCode: localStorage._empcode,
    permission:[]
  }),

  components: {
    DeleteDialog,
    Empimage
  },
  computed: {
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
    ...mapState("filter", ["Employee_List"]),
     //...mapState("permissionmenu", ["permission_List"]),
  

    selectAllEmp() {
      return this.name.length === this.Employee_list.length;
    },
    selectSomeEmp() {
      console.log(this.name);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  created: async function() {
     await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("ImportTimeAttendance");
    this.admin = localStorage._is_admin;
    this.doNewGuid();
    this.getEmployee("newData");
    this.getProfileBranchList();
    this.commitSetToolbar({ patternTool: "0" });
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),
      checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    goto(path) {
      this.$router.push("/" + path);
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    doNewGuid() {
      this.datas.code = Utils.newGuid("TA");
    },
    checktab() {
      this.number_tab ;
      console.log(this.number_tab);
    },
    CreateDoc() {
      let v = this;
      if (v.name.length > 0) {
        console.log(this.number_tab);
        this.dialog_create = true;
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
        this.snack_model.type = "error";
      }
    },
    DownloadExampleExcel() {
      let v = this;
      switch (this.number_tab) {
        case 0: //ขาดงาน
              v.detail_example =[]; 
              v.head_example = ["รหัส","วันที่","ชั่วโมงขาดรวม","หมายเหตุ"];
              if (v.name.length > 0) {
                if(v.form_dialog_create.date !=""){
                  v.dialog_create = false;
                
                v.name.forEach(function(data) {
                  let value = data.split(" - ");
                  console.log(value[0] + " : " + value[1]);
                  v.detail_example.push({
                    รหัส: value[0],
                    ชื่อ: value[1],
                    วันที่: "2019-09-01",
                    ชั่วโมงขาดรวม: "1.0",
                    หมายเหตุ: "ขาดงาน",
                  });
                });
                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(
                  v.detail_example,
                  v.head_example,
                  config
                );
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  wb,
                  Example,
                  "ลงเวลา"
                );
                XLSX.writeFile(wb, "ลงเวลา" + ".xlsx");
              }
              else{
                  this.snack_model.status = true;
                this.snack_model.msg = "กรุณากรอกวันที่มีผล";
                this.snack_model.type = "error";
              } 
              }else {
                this.snack_model.status = true;
                this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
                this.snack_model.type = "error";
              }
              this.form_dialog_create.date= "";
              this.form_dialog_create.remark= "";
          break;
        case 1: //ลา
           v.detail_example =[]; 
              v.head_example = ["รหัส","วันที่","ชั่วโมงลารวม","หมายเหตุ"];
              if (v.name.length > 0) {
                if(v.form_dialog_create.date !=""){
                  v.dialog_create = false;
                
                v.name.forEach(function(data) {
                  let value = data.split(" - ");
                  console.log(value[0] + " : " + value[1]);
                  v.detail_example.push({
                    รหัส: value[0],
                    ชื่อ: value[1],
                    วันที่: "2019-09-01",
                    ชั่วโมงลารวม: "1.0",
                    หมายเหตุ: "ลางาน",
                  });
                });
                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(
                  v.detail_example,
                  v.head_example,
                  config
                );
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  wb,
                  Example,
                  "ลงเวลา"
                );
                XLSX.writeFile(wb, "ลงเวลา" + ".xlsx");
              }
              else{
                  this.snack_model.status = true;
                this.snack_model.msg = "กรุณากรอกวันที่มีผล";
                this.snack_model.type = "error";
              } 
              }else {
                this.snack_model.status = true;
                this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
                this.snack_model.type = "error";
              }
              this.form_dialog_create.date= "";
              this.form_dialog_create.remark= "";
          break;
          case 2:
            v.detail_example =[]; 
              v.head_example = ["รหัส","วันที่","สายรวม","หมายเหตุ"];
              if (v.name.length > 0) {
                if(v.form_dialog_create.date !=""){
                  v.dialog_create = false;
                
                v.name.forEach(function(data) {
                  let value = data.split(" - ");
                  console.log(value[0] + " : " + value[1]);
                  v.detail_example.push({
                    รหัส: value[0],
                    ชื่อ: value[1],
                    วันที่: "2019-09-01",
                    สายรวม: "1.0",
                    หมายเหตุ: "มาสาย",
                  });
                });
                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(
                  v.detail_example,
                  v.head_example,
                  config
                );
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  wb,
                  Example,
                  "ลงเวลา"
                );
                XLSX.writeFile(wb, "ลงเวลา" + ".xlsx");
              }
              else{
                  this.snack_model.status = true;
                this.snack_model.msg = "กรุณากรอกวันที่มีผล";
                this.snack_model.type = "error";
              } 
              }else {
                this.snack_model.status = true;
                this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
                this.snack_model.type = "error";
              }
              this.form_dialog_create.date= "";
              this.form_dialog_create.remark= "";
          break;
          case 3:
             v.detail_example =[]; 
              v.head_example = ["รหัส","วันที่","ออกก่อนเวลารวม","หมายเหตุ"];
              if (v.name.length > 0) {
                if(v.form_dialog_create.date !=""){
                  v.dialog_create = false;
                
                v.name.forEach(function(data) {
                  let value = data.split(" - ");
                  console.log(value[0] + " : " + value[1]);
                  v.detail_example.push({
                    รหัส: value[0],
                    ชื่อ: value[1],
                    วันที่: "2019-09-01",
                    ออกก่อนเวลารวม: "1.0",
                    หมายเหตุ: "ออกก่อนเวลา",
                  });
                });
                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(
                  v.detail_example,
                  v.head_example,
                  config
                );
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  wb,
                  Example,
                  "ลงเวลา"
                );
                XLSX.writeFile(wb, "ลงเวลา" + ".xlsx");
              }
              else{
                  this.snack_model.status = true;
                this.snack_model.msg = "กรุณากรอกวันที่มีผล";
                this.snack_model.type = "error";
              } 
              }else {
                this.snack_model.status = true;
                this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
                this.snack_model.type = "error";
              }
              this.form_dialog_create.date= "";
              this.form_dialog_create.remark= "";
          break;
           case 4: v.detail_example =[]; 
              v.head_example = ["รหัส","วันที่","วันหยุดพิเศษ","หมายเหตุ"];
              if (v.name.length > 0) {
                if(v.form_dialog_create.date !=""){
                  v.dialog_create = false;
                
                v.name.forEach(function(data) {
                  let value = data.split(" - ");
                  console.log(value[0] + " : " + value[1]);
                  v.detail_example.push({
                    รหัส: value[0],
                    ชื่อ: value[1],
                    วันที่: "2019-09-01",
                    วันหยุดพิเศษ: "1",
                    หมายเหตุ: "วันหยุดพิเศษ",
                  });
                });
                var config = { raw: true, type: "string" };
                var Example = XLSX.utils.json_to_sheet(
                  v.detail_example,
                  v.head_example,
                  config
                );
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                  wb,
                  Example,
                  "ลงเวลา"
                );
                XLSX.writeFile(wb, "ลงเวลา" + ".xlsx");
              }
              else{
                  this.snack_model.status = true;
                this.snack_model.msg = "กรุณากรอกวันที่มีผล";
                this.snack_model.type = "error";
              } 
              }else {
                this.snack_model.status = true;
                this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
                this.snack_model.type = "error";
              }
              this.form_dialog_create.date= "";
              this.form_dialog_create.remark= "";
          break;
      
        default:
          break;
      }
     
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function(e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        console.log(v.results);
        console.log("5555");
        for (let index = 0; index < v.results.length; index++) {
          if (
            v.results[index].emp_code != " " &&
            v.results[index].check_in_time != " " &&
            v.results[index].remark != " "
          ) {
            v.datas.details.push({
              code: v.results[index].emp_code,
              check_in_time: v.results[index].check_in_time,
              remark: v.results[index].remark,
            });
          } else {
            v.snack_model.status = true;
            v.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
            v.snack_model.type = "error";
          }
        }
        console.log(v.datas);
        for (let index = 0; index < v.results.length; index++) {
          v.form_datas.push({
            usercode: v.results[index].emp_code,
            check_in_time: v.results[index].check_in_time,
            remark: v.results[index].remark
          });
        }
        console.log("form_datas");
        console.log(v.form_datas);
        DocumentService.createCheckinout(v.form_datas)
          .then(res => {
            v.CheckInOutData = res.data;
            console.log("CheckDetail");
            console.log(v.CheckInOutData);
          })
          .catch(err => {
            v.snack_model.status = true;
            v.snack_model.msg = "ไม่พบข้อมูล";
            v.snack_model.type = "error";
          });
      };
      reader.onerror = function(e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },

    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = res.data.content;
            console.log("eeee", this.branch_items);
          } else {
            console.log("ddddd");
            console.log(this.Employee_List);
            this.Employee_List.forEach(emp => {
              this.Employee_list.push(emp);
            });
            console.log(this.Employee_list);
          }
        })
        .catch(err => {
          console.log(err);

          console.log("ddddd");
          this.Employee_List.forEach(emp => {
            this.Employee_list.push(emp);
          });
          console.log(this.Employee_list);
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then(res => {
          this.department_items = res.data;
          console.log(this.department_items);
          this.getEmployeeList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmployeeList() {
      var position = "";
      var search = "";
      var page = "";
      EmployeeService.getEmployee(
        this.branch,
        this.department,
        position,
        search,
        page
      )
        .then(res => {
          this.Employee_items = res.data.content;
          this.Employee_list = [];
          this.Employee_items.forEach(emp => {
            if (emp.is_active) {
              this.Employee_list.push({
                code: emp.code,
                name: emp.code + " - " + emp.first_name + " " + emp.last_name
              });
            }
          });
          console.log(this.Employee_list);
        })
        .catch(err => {
          console.log(err);
        });
    },

    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    deleteItem(data, index) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.delete") +
        " " +
        data.emp_code +
        " " +
        data.name +
        "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.index = index;
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_dialog = data;
      this.index = index;
    },

    onDelete() {
     
      //this.finger_scan_data.splice(this.delete_dialog_data.index, 1);
      this.datas.details.splice(this.delete_dialog_data.index, 1);
     
    },
    timedRefresh(timeoutPeriod) {
      setTimeout("location.reload(true);", timeoutPeriod);
    },
    onSave() {
      let v = this;
      let datascan = [];
      let date = "";
      v.finger_scan_data.forEach(data => {
        if (data.status == false) {
          v.checkdata = false;
        }
      });

      console.log(v.checkdata);
      if (v.checkdata != false) {
        console.log(v.datas);
        v.datas.details.forEach(detail => {
          let date =
            detail.date_finger_scan + " " + detail.time_finger_scan + ":00.0";
          datascan.push({
            usercode: detail.emp_code,
            doc_no: v.datas.code,
            remark: v.datas.remark,
            check_in_time: date
          });
        });

        console.log("666", datascan);

        DocumentService.createCheckinout(datascan)
          .then(res => {
            v.snack_model.status = true;
            v.snack_model.msg = "save success";
            v.snack_model.type = "success";
            v.goto("checkinout/list");
          })
          .catch(err => {
            v.snack_model.status = true;
            v.snack_model.msg = err.message;
            v.snack_model.type = "error";
          });
      } else {
        v.snack_model.status = true;
        v.snack_model.msg = "กรุณาตรวจสอบข้อมูลและทำการอัพโหลดไฟล์ใหม่";
        v.snack_model.type = "error";
        window.onload = this.timedRefresh(1500);
      }
    },

    onUpdate() {
      let v = this;
      (v.datas.details[v.index].emp_code = v.form_dialog.emp_code),
        (v.datas.details[v.index].name = v.form_dialog.name),
        (v.datas.details[v.index].date_finger_scan =
          v.form_dialog.date_finger_scan),
        (v.datas.details[v.index].time_finger_scan =
          v.form_dialog.time_finger_scan),
        (v.datas.details[v.index].remark = v.form_dialog.remark),
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
    },
    back() {
      location.reload();
    },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_list.forEach(data => {
            this.name.push(data.name);
          });
        }
      });
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
</style>